import { fundingNavigationManifest } from '../generated/navigation.js';
const routes = fundingNavigationManifest.checkout.events;
/** Provider gates cannot take over an unselected, ordinary funding entry. */
export function isFundingHostPicker(checkout, directPurchase, authenticationRequested) {
    return (!directPurchase &&
        !authenticationRequested &&
        !checkout.verificationFromProfile &&
        !checkout.method &&
        !checkout.operation &&
        !checkout.pendingId &&
        !checkout.attemptId &&
        !checkout.paymentSignature &&
        (checkout.state === 'terms' || checkout.state === 'customer_verification'));
}
export function initialCheckoutState(operation, discovery, method, authenticationRequested = false, verificationRequested = false, directPurchase = false) {
    if (operation && !['created', 'action_required'].includes(operation.status))
        return routes.payment_uncertain;
    if (discovery?.customerVerification &&
        (discovery.customerVerification.status !== 'active' || discovery.customerVerification.challenge))
        return routes.customer_verification_required;
    if (discovery?.needsContactVerification)
        return method
            ? verificationRequested
                ? routes.contacts_required
                : routes.method_selected
            : routes.change_method;
    if (discovery?.status === 'termsAcceptanceRequired')
        return routes.terms_required;
    if (discovery?.status === 'connectionRequired' &&
        directPurchase &&
        method &&
        !authenticationRequested)
        return fundingNavigationManifest.direct_token_purchase.initial;
    if (discovery?.status === 'connectionRequired')
        if (discovery.methods.length > 0 && !authenticationRequested)
            return method
                ? directPurchase
                    ? fundingNavigationManifest.direct_token_purchase.initial
                    : routes.method_selected
                : routes.change_method;
    if (discovery?.status === 'connectionRequired')
        return authenticationRequested &&
            discovery.authenticationAvailable &&
            discovery.authenticationReason !== 'account_mismatch'
            ? routes.connect_requested
            : routes.connection_required;
    if (discovery?.status && discovery.status !== 'available')
        return routes.connection_unavailable;
    return method ? routes.method_selected : routes.change_method;
}
export function authenticatedCheckoutState(status, hasAttempt) {
    if (hasAttempt)
        return routes.payment_uncertain;
    if (status === 'termsAcceptanceRequired')
        return routes.terms_required;
    return status === 'active' ? null : routes.connection_unavailable;
}
export function authenticatedCheckoutEvent(status, hasAttempt) {
    const next = authenticatedCheckoutState(status, hasAttempt);
    return next === 'status'
        ? 'payment_uncertain'
        : next === 'terms'
            ? 'terms_required'
            : next === 'unavailable'
                ? 'connection_unavailable'
                : 'authentication_complete';
}
